module.exports = __webpack_public_path__ + "img/bq.c109cd67.svg";